<template>
  <v-app>
    <v-toolbar color="primary" fixed dark app><v-toolbar-title class="ml-0 pl-3"> {{ $t("common.appName") }} </v-toolbar-title>
      <v-spacer></v-spacer>
      <language-switcher />
    </v-toolbar>
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-card style="width: 500px" v-if="page == 0">
            <v-card-title primary-title>
              <div>
                <div class="headline pl-2 pa-1">
                  {{ $t("login.welcome") }}
                </div>
              </div>
            </v-card-title>
            <v-form ref="sendCodeForm" v-model="codeForm" class="pa-4 pt-6">
              <v-text-field outline v-model="model.username" :rules="[rules.email]" :label="$t('login.email')" type="email"
                @keyup.enter="sendCode"></v-text-field>
              <v-text-field outline v-model="model.password" :rules="[rules.password]" :label="$t('login.password')"
                style="min-height: 96px" type="password" dense @keyup.enter="sendCode"></v-text-field>

              <v-layout row wrap>
                <v-flex>
                  <v-checkbox :label="$t('login.rememberMe')" color="red" v-model="model.remember_me">
                  </v-checkbox>

                  <v-subheader style="padding-top: 15px"><router-link to="/reset-password-email">{{
                      $t("login.resetPassword") }}</router-link></v-subheader>
                </v-flex>
              </v-layout>
              <v-btn @click="sendCode" :loading="loading" block color="secondary" dark>{{ $t("login.login") }}</v-btn>
            </v-form>
          </v-card>
          <v-card style="width: 500px" v-if="page == 1">
            <v-card-title primary-title>
              <div>
                <div class="headline pl-2 pa-1">
                  {{ $t("login.enterCode") }}
                </div>
              </div>
            </v-card-title>
            <v-form ref="logForm" v-model="loginForm" class="pa-4 pt-6" @submit.prevent="login">
              <v-text-field outline v-model="model.code" :label="$t('login.code')" type="text"></v-text-field>


              <v-btn @click="login" :loading="loading" block color="secondary" dark>{{ $t("login.verify") }}</v-btn>
            </v-form>
          </v-card>
        </v-layout>
      </v-container>

    </v-content>
  </v-app>
</template>

<script>
import axios from "axios";
import store from "@/store";
import LanguageSwitcher from "@/components/LanguageSwitcher.vue";

export default {
  title() {
    return this.$t("login.title");
  },
  components: {
    LanguageSwitcher,
  },
  data: () => ({
    loading: false,
    error: false,
    model: {
      username: "",
      password: "",
      code: "",
      remember_me: "",
    },
    page: 0,
    socket: null,
    dialog: false,
    email: undefined,
    codeForm: false,
    loginForm: false,
    isLoading: false,
    password: undefined,
  }),
  computed: {
    rules() {
      return {
        email: (v) => !!(v || "").match(/@/) || this.$t("login.rules.email"),
        length: (len) => (v) =>
          (v || "").length == len || this.$t("login.rules.length", { length: len }),
        password: (v) =>
          !!(v || "").match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()=+\-_[\]{}|;':",.<>/?éèêë])[A-Za-z\d!@#$%^&*()=+\-_[\]{}|;':",.<>/?éèêë]{8,15}$/) || this.$t("login.rules.password"),
        required: (v) => !!v || this.$t("login.rules.required"),
      };
    },
  },
  // mounted() {
  //   this.axios
  //     .get(this.api.ACTIONS.GET_LOGIN_IDENTFIER)
  //     .then(({ data: { data: qrCode } }) => {
  //       QRCode.toDataURL(qrCode, {
  //         errorCorrection: "high",
  //         version: 4,
  //       }).then((data) => {
  //         this.qrCode = data;
  //         this.socket = io(this.api.SOCKET.GUESTS, {
  //           transportOptions: {
  //             polling: {
  //               extraHeaders: {
  //                 authorization: qrCode,
  //               },
  //             },
  //           },
  //         });
  //         this.socket.on("authenticate", async (token) => {
  //           await this.$store.dispatch("validateToken", token);
  //           // const user = this.$store.state.user;
  //           let next = this.$route.query.next || "/dashboard";
  //           // if (this.airportAgency(user.roles))
  //           //     next = 'airport/create';
  //           window.getApp.$emit("APP_LOGIN_SUCCESS");
  //           await this.$router.push(next);
  //         });
  //       });
  //     });
  // },
  methods: {
    async login() {
      if (this.loading)
        return;
      if (!this.$refs.logForm.validate())
        return;
      this.error = false;
      this.loading = true;
      this.axios
        .post(this.api.ACTIONS.LOGIN, { ...this.model, provider: "users" })
        .then(({ data }) => {
          this.$store.commit("LOGIN", data.data);
          this.$store.commit("USER_NAME", data.data.username);
          // console.log(this.$store.state.USER_NAME);
          let next = "/requests";
          if (this.airportAgency(data.data.roles)) {
            next = "airport/create";
          }
          window.getApp.$emit("APP_LOGIN_SUCCESS");
          this.$router.push(next);
        })
        .catch((err) => {
          console.log(err.message);
          this.error = true;
          let response = err.response;
          if (response) {
            window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
            console.log(response.data);
          } else {
            window.getApp.$emit("SHOW_TOAST", this.$t("login.checkInfo"), "red");
          }
        })
        .then(() => (this.loading = false));
    },
    async sendCode() {
      if (this.loading)
        return;
      if (!this.$refs.sendCodeForm.validate())
        return;
      this.error = false;
      this.loading = true;
      this.axios
        .post(this.api.ACTIONS.SEND_CODE, { ...this.model, provider: "users" })
        .then(({ data }) => {
          this.page = 1;
        })
        .catch((err) => {
          console.log(err.message);
          this.error = true;
          let response = err.response;
          if (response) {
            window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
            console.log(response.data);
          } else {
            window.getApp.$emit("SHOW_TOAST", this.$t("login.checkInfo"), "red");
          }
        })
        .then(() => (this.loading = false));
    }
  },
};
</script>
<style scoped lang="css">
#login {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
</style>
